"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var SmileyDiv = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition: all 0.5s;\n  text-align: center;\n  display: grid;\n  flex: 1;\n  cursor: pointer;\n  ::before {\n    font-size: 2.5rem;\n    transition: inherit;\n    font-family: Segoe UI Emoji;\n    content: '", "';\n    opacity: ", ";\n    display: inline-block;\n  }\n  :hover::before {\n    opacity: 1.0\n  }\n\n  ::after {\n    font-size: 1rem;\n    transition: inherit;\n    content: '", "';\n    opacity: ", ";\n     display: inline-block;\n  }\n  :hover::after {\n    opacity: 1.0\n  }\n\n"])), function (props) {
  return props.emoji;
}, function (props) {
  return props.selected ? 1.0 : 0.2;
}, function (props) {
  return props.label;
}, function (props) {
  return props.selected ? 1.0 : 0.0;
});
SmileyDiv.propTypes = {
  emoji: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  selected: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = SmileyDiv;